import Stack from "@mui/material/Stack";
import { MenuBarColorPicker } from "@src/components/RichTextEditor/MenuBar/MenuBarColorPicker";
import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

import { InputProps } from "./types";
import { useValidatedInput } from "./useValidatedInput";

const COLOR_REGEX =
  /^(#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})?|rgba?\(\d{1,3},\s*\d{1,3},\s*\d{1,3}(,\s*(0|1|0?\.\d+))?\))$/;

const isValidColor = (v: string) => v === "" || COLOR_REGEX.test(v);

export const ColorInput = ({ label, value, onChange }: InputProps) => {
  const field = useValidatedInput(value, onChange, isValidColor);

  const handlePickerChange = (color: string) => {
    // Picker always produces valid values, so bypass validation
    field.onChange({
      target: { value: color },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <Stack spacing={1}>
      <Panel.Label>{label}</Panel.Label>
      <Stack direction="row" alignItems="center" spacing={1}>
        <MenuBarColorPicker
          value={value}
          onChange={handlePickerChange}
          disabled={false}
        />
        <Panel.TextField {...field} />
      </Stack>
    </Stack>
  );
};
